import { useControlledValue } from "../helpers/useControlledValue.js";
export function useMulti(props, dateLib) {
  const {
    selected: initiallySelected,
    required,
    onSelect
  } = props;
  const [internallySelected, setSelected] = useControlledValue(initiallySelected, onSelect ? initiallySelected : undefined);
  const selected = !onSelect ? internallySelected : initiallySelected;
  const {
    isSameDay
  } = dateLib;
  const isSelected = date => {
    var _selected$some;
    return (_selected$some = selected === null || selected === void 0 ? void 0 : selected.some(d => isSameDay(d, date))) !== null && _selected$some !== void 0 ? _selected$some : false;
  };
  const {
    min,
    max
  } = props;
  const select = (triggerDate, modifiers, e) => {
    let newDates = [...(selected !== null && selected !== void 0 ? selected : [])];
    if (isSelected(triggerDate)) {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === min) {
        // Min value reached, do nothing
        return;
      }
      if (required && (selected === null || selected === void 0 ? void 0 : selected.length) === 1) {
        // Required value already selected do nothing
        return;
      }
      newDates = selected === null || selected === void 0 ? void 0 : selected.filter(d => !isSameDay(d, triggerDate));
    } else {
      if ((selected === null || selected === void 0 ? void 0 : selected.length) === max) {
        // Max value reached, reset the selection to date
        newDates = [triggerDate];
      } else {
        // Add the date to the selection
        newDates = [...newDates, triggerDate];
      }
    }
    if (!onSelect) {
      setSelected(newDates);
    }
    onSelect === null || onSelect === void 0 || onSelect(newDates, triggerDate, modifiers, e);
    return newDates;
  };
  return {
    selected,
    select,
    isSelected
  };
}